const log = require("../shared_utils/log.js");
const BUILTIN_PHYSICS = "builtin_physics";
const {
  getScratchPointOfMouseEvent,
} = require("../shared_utils/coordinates.js");
const { addPartToVM } = require("./utils/add-part.js");
const { sanitizeVariables } = require("./utils/sanitize-state.js");
const { addAppliedGlitchesCodeToPart } = require("./utils/add-part.js");
const uuid = require("./utils/uuid.js");
module.exports = function store(state, emitter) {
  emitter.on("start-importing-part", (partId) => {
    log("start-importing-part", partId);
    if (state.settingSpriteVariable) {
      state.setPartAsSpriteVariable = {
        variableId: state.selectedVariableId,
        glitchApplicationId: state.selectedGlitchApplicationId,
        targetId: state.selectedTargetId,
      };
    }
    emitter.emit('select-part', partId);
    state.importingPart = true;
    emitter.emit("render");
  });

  emitter.on("drop-part-on-game", (e) => {
    log("drop-part-on-game", e);
    const part = state.availableParts.find(
      (p) => p.id === state.selectedPartId
    );
    const coords = getScratchPointOfMouseEvent(e, state.canvas);
    emitter.emit("tutorial-msg-add-part", part.id);

    emitter.emit("push-history", "add-part");
    addPartToVM(part, state.vm, { coords }).then((newPartEntry) => {
      state.addedParts.push(newPartEntry.addedPartEntry);
      const newPart = newPartEntry.target;

      part.exposedVariables.forEach((v) => {
        newPart.lookupOrCreateVariable(uuid(), v.variableName).value = v.value;
      });

      state.vm.runtime.renderer.draw();

      setTimeout(() => {
        console.log("drawing");
        state.vm.runtime.renderer.draw();

        if (state.setPartAsSpriteVariable) {
          const { variableId, glitchApplicationId, targetId } =
            state.setPartAsSpriteVariable;

          state.setPartAsSpriteVariable = null;
          state.settingSpriteVariable = false;
          state.settingSpriteVariable = false;
          state.draggingSpriteVariable = false;
          state.selectedVariableId = null;
          state.selectedGlitchApplicationId = glitchApplicationId;
          const glitchApplication = state.glitchApplications.find(
            (g) => g.id === glitchApplicationId
          );
          const glitchTarget = state.vm.runtime.targets.find(
            (t) => t.id === glitchApplication.targetId
          );
          const variable = glitchTarget.variables[variableId];
          variable.value = newPart.sprite.name;
          emitter.emit("select-target", targetId);
          emitter.emit("select-glitch-application", glitchApplicationId);
          setTimeout(() => {}, 100);
        } else {
          emitter.emit("select-target", newPart.id);
        }
        emitter.emit("apply-glitch", BUILTIN_PHYSICS, newPart.id);
        addAppliedGlitchesCodeToPart(
          newPart,
          state.vm,
          state.availableGlitches,
          state.glitchApplications
        );
        emitter.emit("render");
      }, 100);
    });
    sanitizeVariables(state);
  });

  emitter.on("end-importing-part", () => {
    state.importingPart = false;
    state.selectedPartId = null;
    emitter.emit("render");
  });
};
